"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokenRequest = void 0;
var location_handler_1 = require("../location-handler");
var isTokenRequest = function (url) {
    var baseUrl = (0, location_handler_1.getCurrentEnvBaseApi)({ prefixUri: '/rsp-user-api/api/v2/user/' });
    return url === "".concat(baseUrl, "/token");
};
exports.isTokenRequest = isTokenRequest;
//# sourceMappingURL=is-token-request.js.map